import ApiService from '@services/api.service'
import { store } from '@state/store'
import moment from 'moment'

const EventHistoryService = {
  async getNinetyDayEventHistory() {
    let ninetyDaysAgo = moment()
      .subtract(90, 'days')
      .toISOString()

    let history = await this.getEventHistory(ninetyDaysAgo).catch((err) => {
      throw err
    })

    store.updateNinetyDayEventHistory(history, store.state.timeZoneInfo)
  },

  async getEventHistoriesForSignalTest() {
    let storedEffectiveDate = store.state.systemTest.storedEffectiveDate

    // check to see if effective date in state is a valid date
    if (!isNaN(new Date(storedEffectiveDate).getTime())) {
      let eventHistory = await this.getEventHistory(storedEffectiveDate).catch(
        (err) => {
          throw err
        }
      )

      store.updateSignalTestEventHistory(eventHistory, store.state.timeZoneInfo)
    }
  },

  async getEventHistory(since) {
    let response = await ApiService.get(
      `/EventHistory/site/${store.state.site.siteNumber}?since=${since}`
    ).catch((err) => {
      throw err
    })

    let eventHistory = []
    if (response.data.length > 0) {
      eventHistory = response.data
      eventHistory.sort((a, b) => {
        if (new Date(a.EventDate) > new Date(b.EventDate)) {
          return -1
        }
        if (new Date(a.EventDate) < new Date(b.EventDate)) {
          return 1
        }
        return 0
      })
    }

    return eventHistory
  },
}

export default EventHistoryService
